import {post} from '../utils/ajaxHelper';

function getTranslatedReviews({reviews, language} = {}) {
    const url = `/pdp/translateReviews`;
    const variant = window && window.debugLog && window.debugLog.variant;
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;

    return post(url, {reviews, language, variant, requestMarker});
}

export default getTranslatedReviews;
export {getTranslatedReviews};
